import React from 'react';

import PlainIconButton from '@/components/atoms/PlainIconButton/PlainIconButton';

import { NavigationButtonProps } from './navigation-button.types';
import {
  NavigationIconButton,
  NavigationIconButtonHover,
  NavigationIconButtonLeft,
  NavigationIconButtonRight,
} from './NavigationButton.style';

const NavigationButton: React.FC<NavigationButtonProps> = ({
  position,
  children,
  style,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <PlainIconButton
      onMouseEnter={(e) => {
        setHovered(true);
        onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setHovered(false);
        onMouseLeave?.(e);
      }}
      style={{
        ...NavigationIconButton,
        ...(position === 'left'
          ? NavigationIconButtonLeft
          : NavigationIconButtonRight),
        ...(hovered && NavigationIconButtonHover),
        ...style,
      }}
      {...props}
    >
      {children}
    </PlainIconButton>
  );
};

export default NavigationButton;
